import { React, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Outlet } from "react-router-dom";

const Layout = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  return (
    <div className={isDarkMode ? "dark" : ""}>
      <div className="m-0 flex min-h-screen flex-col items-center justify-between bg-light-secondary-2 p-0 font-google-lobster dark:bg-dark-secondary-1">
        <Header toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
        <Outlet />
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
